import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setConditionCodeModifierOptions as setConditionCodeModifierOptionsAction } from '../store/options.actions'

import { OptionsService } from '../services/options.service'

export function* setConditionCodeModifierOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getConditionCodeModifierOptions])
    const { entity } = response
    yield put(setConditionCodeModifierOptionsAction(entity))
  } catch (e) {
    yield put(throwPcrException(`setConditionCodeModifierOptions() error: ${e}`))
  }
}

export function* setConditionCodeModifierOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setConditionCodeModifierOptions)
}
